import { useCallback } from 'react'
import { message } from 'antd'

import { getErrorMessage } from '../../api/error'
import { httpClient, ROOT_URL } from '../../App'

export const useExportExcel = () => {
  const exportExcel = useCallback(
    async (
      endpoint: string,
      params: Record<string, string | number | undefined> = {}
    ) => {
      try {
        const searchParams = new URLSearchParams()
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== '' && value !== null) {
            searchParams.append(key, String(value))
          }
        })
        const query = searchParams.toString()
        const baseUrl = `${ROOT_URL}/api/v1/${endpoint}`
        const url = query ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}${query}` : baseUrl

        const response = await httpClient.get<{ data?: { url?: string } }>(url)

        const fileUrl = response.data?.data?.url
        if (!fileUrl) {
          throw new Error('Export failed: No download URL returned')
        }

        let downloadUrl = fileUrl
        const environment = process.env.REACT_APP_ENVIRONMENT
        if (environment === 'development') {
          downloadUrl = fileUrl.replace(
            'http://172.188.80.191:10000/',
            'https://azurite.dev.smart.pixitech.asia/'
          )
        }

        window.open(downloadUrl, '_blank')
      } catch (error: unknown) {
        if (error && typeof error === 'object' && 'response' in error) {
          const err = error as { response?: { data?: unknown } }
          if (err.response?.data instanceof Blob) {
            try {
              const text = await (err.response.data as Blob).text()
              const parsed = JSON.parse(text) as { message?: string }
              message.error(parsed?.message || 'Export failed')
              return
            } catch {
              // fallback
            }
          }
        }
        message.error(getErrorMessage(error))
      }
    },
    []
  )

  return { exportExcel }
}
